import {
    Component,
    Input,
    OnInit,
} from '@angular/core';
import {TileType6, UniversalTileView} from "../../../models";
import {
    ControlService, IconService,
    ParametersService,
    SubtitlesService, TilesService
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-universal-status',
    templateUrl: './tile-universal-status.component.html',
    styleUrls: ['./tile-universal-status.component.scss']
})
export class TileUniversalStatusComponent implements OnInit {
    @Input() tile: TileType6;
    universalTile: UniversalTileView;

    constructor(
        private control: ControlService,
        public icon: IconService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
        private tiles: TilesService,
    ) {
    }

    ngOnInit() {
        this.universalTile = this.tiles.setUniversalTile(this.tile.elementMenu, this.tile);
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor' : 'setting'
    }
}
